<template>
  <v-card raised class="mb-4" elevation="5">
    <v-container>
      <v-layout wrap>
        <v-flex sm11>
          <h2 class="grey--text text--darken-1">
            <v-icon style="margin-right:10px">mdi-bookmark-outline</v-icon>
            {{ aspect.title }}
          </h2>
        </v-flex>
        <v-flex sm1>
          <v-icon @click="dialog = true" class="mr-2">mdi-pencil-outline</v-icon>
          <v-icon @click="dialogDelete = true" class="mr-2">mdi-close</v-icon>
          <br />
          <br />
        </v-flex>

        <v-layout wrap class="pa-2">
          <template v-if="aspect.rangos.length > 0">
            <v-flex sm1>
              <p>RANGO</p>
            </v-flex>
            <v-flex sm1>
              <p>MÍNIMO</p>
            </v-flex>
            <v-flex sm1>
              <p>MÁXIMO</p>
            </v-flex>
            <v-flex sm4>
              <p>DIAGNÓSTICO</p>
            </v-flex>
            <v-flex sm4>
              <p>RECOMENDACIONES</p>
            </v-flex>
          </template>

          <!-- for de los aspectos -->
          <v-flex sm12 v-if="aspect.rangos.length > 0">
            <Range
              v-for="(rango,index) in aspect.rangos"
              :key="index"
              :rango="rango"
              @update="updateAspects"
            ></Range>
          </v-flex>
          <v-flex sm12>
            <v-btn @click="dialogRange = true" block class="grey lighten-3">Agregar rango</v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>

    <!-- Ventana para editar aspecto -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Editar Aspecto</v-card-title>

        <v-form ref="form" @submit.prevent="send">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="title" label="Aspecto" :rules="requiredRule"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para crear rango -->
    <v-dialog v-model="dialogRange" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Crear rango</v-card-title>

        <v-form ref="formRange" @submit.prevent="sendRange">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="rango" label="Rango" :rules="requiredRule" type="number"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="minRango"
                      label="Rango minímo"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="maxRango"
                      label="Rango máximo"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field v-model="diagnosis" label="Diagnóstico" :rules="requiredRule"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="recommendation"
                      label="Recomendación"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogRange = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Crear</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para eliminar -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Eliminar aspecto</v-card-title>

        <v-card-text class="title">¿Estás seguro de eliminar a este aspecto?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">cancelar</v-btn>
          <v-btn color="primary" text @click="deleteAspect">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" right top :timeout="6000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import Range from "@/components/Range";
export default {
  name: "ClientCard",
  components: {
    Range
  },
  props: {
    aspect: Object
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      emailRule: [
        v => !!v || "Este campo es obligatorio",
        v => /.+@.+\..+/.test(v) || "El correo debe ser valido"
      ],

      title: this.aspect.title,
      snackbar: false,
      message: "",
      ranges: this.aspect.rangos,

      rango: "",
      minRango: "",
      maxRango: "",
      diagnosis: "",
      recommendation: "",
      dialogRange: false,

      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          idAspect: this.aspect.idAspect,
          title: this.title,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(this.host + "/aspects/update.php", this.createFormData(data))
          .then(response => {
            if (response.data.status) {
              this.dialog = false;
              this.$emit("updateAspects");
            } else {
              this.snackbar = true;
              this.message = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    sendRange() {
      if (this.$refs.formRange.validate()) {
        let validation = false;
        for (let element of this.aspect.rangos) {
          if (
            element.rango != this.rango &&
            (element.minRango != this.minRango ||
              element.maxRango != this.maxRango)
          ) {
            validation = false;
          } else {
            validation = true;
            break;
          }
        }

        if (validation) {
          this.message =
            "Asegurate de que el número de rango es diferente y también el rango mínimo y máximo";
          this.dialogRange = false;
          this.snackbar = true;
        } else {
          let data = {
            rango: this.rango,
            minRango: this.minRango,
            maxRango: this.maxRango,
            diagnosis: this.diagnosis,
            recommendation: this.recommendation,
            idAspect: this.aspect.idAspect,
            idUserVerify: sessionStorage.getItem("authorization")
          };

          axios
            .post(this.host + "/rango/create.php", this.createFormData(data))
            .then(response => {
              if (response.data.status) {
                this.dialogRange = false;
                this.message = response.data.message;
                this.snackbar = true;
                this.$emit("updateAspects");
                this.rango = "";
                this.minRango = "";
                this.maxRango = "";
                this.diagnosis = "";
                this.recommendation = "";
                this.$refs.formRange.resetValidation();
              } else {
                this.snackbar = true;
                this.message = response.data.message;
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      }
    },

    deleteAspect() {
      let data = {
        idAspect: this.aspect.idAspect,
        idUserVerify: sessionStorage.getItem("authorization")
      };
      axios
        .post(this.host + "/aspects/delete.php", this.createFormData(data))
        .then(response => {
          this.dialogDelete = false;
          this.$emit("updateAspects");
          if (!response.data.status) {
            this.snackbar = true;
            this.message = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateAspects() {
      this.$emit("updateAspects");
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>
<style scoped>
.switch {
  width: 50px;
  display: inline-block;
}
</style>